import React, { useEffect } from "react";
import { PRIVACY_POLICY_URL } from "@/helpers/legalLinks";

const GitchaPrivacyPolicy = () => {
  useEffect(() => {
    window.location.replace(PRIVACY_POLICY_URL);
  }, []);

  return (
    <p className="text-center p-5">
      Opening the <a href={PRIVACY_POLICY_URL}>Privacy Policy</a>…
    </p>
  );
};

export default GitchaPrivacyPolicy;
